var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"px-10",attrs:{"fluid":""}},[_c('v-img',{attrs:{"width":"200px","contain":"","src":require('@/assets/main-logo.png')}}),_c('div',{staticClass:"welcome-message"},[_vm._v(" Welcome to EKA basketball cms ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }